export default __webpack_public_path__ + "static/media/mountain-view-golden-hour-photography-733168.218a0b5f.jpg";